module.exports = __webpack_public_path__ + "img/htcm_04.9420deed.jpg";